import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export function useDeletePolicy() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (policyVersionId: string) => {
			try {
				return (
					await api.delete(`/management/policy-version/delete`, {
						data: {
							policyVersionId,
						},
					})
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao apagar o termo.');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['policies'] });
		},

		onError: (error) => {
			console.error(
				'Erro ao apagar o termo:',
				getApiErrorMessage(error, 'Erro ao apagar o termo.')
			);
		},
	});
}
